/** TanStack Query keys for the engage screens; every key starts with the workspace id. */
export const engageKeys = {
  agents: (wsId: string) => ["ws", wsId, "engage", "agents"] as const,
  audiences: (wsId: string) => ["ws", wsId, "engage", "audiences"] as const,
  inbox: (wsId: string) => ["ws", wsId, "inbox"] as const,
  gaps: (wsId: string) => ["ws", wsId, "gaps"] as const,
  leads: (wsId: string) => ["ws", wsId, "leads"] as const,
  announcements: (wsId: string) => ["ws", wsId, "announcements"] as const,
  analytics: (wsId: string) => ["ws", wsId, "analytics"] as const,
} as const;
